import React from 'react';
import { RenderField } from '@zola/zola-ui/src/components/Form/RenderField';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import cx from 'classnames';
import { findProductLookById, resolveMatchingSku } from './helpers';
// component template for most of the content

export const renderPersonalizationAction = (clickHandler) => (
  <ButtonV2
    onClick={clickHandler}
    variant="primary"
    type="submit"
    className="pdp-personalization-button"
  >
    <div>Personalize</div>
  </ButtonV2>
);

export const renderActionButton = (action, clickHandler) => {
  const className = action.primary ? 'add-button-primary' : 'add-button-secondary';
  const disableButton = action.disabled;
  const toolTip = action.tooltip;
  if (toolTip) {
    return (
      <ButtonV2
        key={action.label}
        onClick={clickHandler}
        disabled={disableButton}
        variant={action.primary ? 'primary' : 'secondary'}
        type="submit"
        className={cx('pdp-add-button', className)}
        data-tooltip={toolTip}
        compact
      >
        <div>{action.label}</div>
      </ButtonV2>
    );
  }
  return (
    <ButtonV2
      key={action.label}
      onClick={clickHandler}
      disabled={disableButton}
      variant={action.primary ? 'primary' : 'secondary'}
      type="submit"
      className={cx('pdp-add-button', className)}
      compact
    >
      <div>{action.label}</div>
    </ButtonV2>
  );
};

export const renderQuantity = (productData, quantity, setQuantity) => (
  <>
    <div className="quantity-label">Quantity:</div>
    <RenderField
      disabled={productData.lock_quantity}
      type="number"
      className="pdp-qty-input"
      input={{
        name: 'quantity',
        value: quantity,
        onChange: (e) => {
          if (e.target.value === '') return setQuantity(e.target.value);
          if (e.target.value <= 0 || e.target.value > 100) return null;
          return setQuantity(e.target.value);
        },
        onBlur: (e) => {
          if (e.target.value <= 0 || e.target.value > 100) return;
          setQuantity(e.target.value);
        },
      }}
    />
  </>
);

export const updateProductLook = (productLookId, productData, setters, history) => {
  const { setActiveProductLook, setProductAttributes, setActiveSku, isKitProduct } = setters;
  // find the new product look
  const productLook = findProductLookById(productLookId, productData.product_look_views);

  // reset the active product look, empty out selected attributes, and active SKU
  setActiveProductLook(productLook);
  setProductAttributes({});
  setActiveSku(resolveMatchingSku(productLook.sku_previews, {}));

  // update the browser URL only if it's the main PDP
  if (!isKitProduct) {
    history
      ? history.replace({
          state: { productLookKey: productLook.key },
          pathname: `/shop/product/${productLook.key}`,
        })
      : window.history.replaceState({}, '', productLook.key);
  }
};

export const MSRPToolTip = `MSRP refers to the manufacturer’s suggested
retail price, which may not be the prevailing
market price or the regular retail price.`;

export const handleAttributeChange = (
  productData,
  productAttributes,
  activeProductLook,
  setters
) => {
  const { setProductAttributes, setActiveSku } = setters;
  return (e, productLookId) => {
    const { value } = e.target;
    const attributeKey = e.target.getAttribute('attribute');
    const updatedAttributes = Object.assign({}, productAttributes);

    // if they selected the "empty" option, just unset that value
    // TODO: this may not work well with product look attributes
    if (value === 'Select...') {
      delete updatedAttributes[attributeKey];
      setProductAttributes(updatedAttributes);
      // TODO: setActiveSku here?
      return;
    }

    // if the attribute changes the product look, then special handling is required
    if (productLookId) {
      updateProductLook(productLookId, productData, setters);
      return;
    }

    // update the currently selected attributes, and re-resolve the active SKU
    updatedAttributes[attributeKey] = value;
    setProductAttributes(updatedAttributes);
    setActiveSku(resolveMatchingSku(activeProductLook.sku_previews, updatedAttributes));
  };
};
